import { create } from "zustand";

const STORAGE_KEY = "calendarPreferences";

interface CalendarPreferences {
  locale: string;
  firstDayOfWeek: number;
  yearDrillTarget: "day" | "month";
  yearDensityMode: "dot" | "heatmap" | "count";
  weekDayCount: number;
}

const DEFAULTS: CalendarPreferences = {
  locale: "en",
  firstDayOfWeek: 1,
  yearDrillTarget: "month",
  yearDensityMode: "dot",
  weekDayCount: 7,
};

function loadPreferences(): CalendarPreferences {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return DEFAULTS;
    return { ...DEFAULTS, ...JSON.parse(stored) };
  } catch {
    return DEFAULTS;
  }
}

function savePreferences(prefs: CalendarPreferences) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}

interface PreferencesState extends CalendarPreferences {
  setPreference: <K extends keyof CalendarPreferences>(key: K, value: CalendarPreferences[K]) => void;
}

export const usePreferencesStore = create<PreferencesState>((set, get) => ({
  ...loadPreferences(),

  setPreference: (key, value) => {
    const next = { ...get(), [key]: value };
    // Strip the action before persisting
    const { setPreference: _, ...prefs } = next;
    savePreferences(prefs as CalendarPreferences);
    set({ [key]: value });
  },
}));
